import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDeleteLeft, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import MenuButton from '../Common/Menu/MenuButton';
import { useState } from 'react';
import PopUpMessage from '../Common/PopUpMessages/PopUpMessage';
import Logo from '../Common/Logo';


const WorkerLogin = () => {
    const [passCode, setPassCode] = useState("");
    const [warningMessage, setWarningMessage] = useState(null);
    const updateInput = (value) => {
        if (passCode.length !== 10) {
            setPassCode(passCode + value);

        } else {
            setWarningMessage("Maximum number of digits is 10")
        }
    }
    const deleteInput = () => {
        setPassCode(passCode.substring(0, passCode.length - 1));
        setWarningMessage(null, 100);
    }
    function ButtonLogin({ value, color, isDelete }) {
        if (color === "number") {
            color = "bg-white text-[#6b7280] hover:bg-blue-200 hover:text-white"
        }
        else if (color === "delete") {
            color = "bg-[#d65858] text-[white] hover:bg-[#dc2626] hover:text-white"
        }
        else if (color === "confirmed") {
            color = "bg-green-600 text-[white] hover:bg-green-800 hover:text-white"
        }
        return <div onClick={!isDelete ? () => updateInput(value) : () => deleteInput(value)} className={"shadow-md w-[28vh] h-[16vh] mx-[1vh] my-[1vh] font-bold border-[0px] text-[10vh] rounded-lg flex justify-center items-center max-lg:w-[31.333%] max-lg:mx-[1%] max-lg:my-[1%] max-lg:h-[16%] max-lg:text-[7vh] " + color}> {value}</div>
    }
    return (

        <div id='workerloginform' className="w-screen h-screen flex flex-col items-center justify-center text-white bg-[#f9f9f9] overflow-hidden p-50 flex-wrap relative">
            <PopUpMessage />
            <Logo />
            <div className="h-[90vh] w-[90vh] flex justify-start items-start flex-wrap content-start rounded-lg max-lg:h-auto max-lg:w-[90vw] max-lg:p-[0] max-lg:mt-[30vh]">
                <ButtonLogin value={"1"} color={"number"} />
                <ButtonLogin value={"2"} color={"number"} />
                <ButtonLogin value={"3"} color={"number"} />
                <ButtonLogin value={"4"} color={"number"} />
                <ButtonLogin value={"5"} color={"number"} />
                <ButtonLogin value={"6"} color={"number"} />
                <ButtonLogin value={"7"} color={"number"} />
                <ButtonLogin value={"8"} color={"number"} />
                <ButtonLogin value={"9"} color={"number"} />
                <ButtonLogin value={<FontAwesomeIcon icon={faDeleteLeft} />} color={"delete"} isDelete={true} />
                <ButtonLogin value={"0"} color={"number"} />
                <ButtonLogin value={<FontAwesomeIcon icon={faCircleCheck} />} color={"confirmed"} />
                <input type={'password'} maxLength="10" placeholder="Password" className="w-full h-{8vh} leading-[8vh] text-center text-[#1b1b1b] text-[3vh] focus:outline-none max-lg:mt-[5%] max-lg:h-[8vh] " value={passCode}></input>
            </div>
        </div >
    )

}
export default WorkerLogin
